module.exports = __webpack_public_path__ + "img/car.14261ed9.png";